const listeners = new Set<() => void>();

/** Carries no identity or credentials; transports report authoritative 401 responses. */
export function invalidateSession(): void {
  for (const listener of listeners) listener();
}

export function subscribeSessionInvalidation(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export const SESSION_REVOCATION_CHANNEL = 'omaplus-session-revocation';

export function openSessionRevocationChannel(): BroadcastChannel | undefined {
  if (typeof window === 'undefined' || typeof window.BroadcastChannel !== 'function')
    return undefined;
  try {
    return new window.BroadcastChannel(SESSION_REVOCATION_CHANNEL);
  } catch {
    // Cross-tab notification is optional; authoritative foreground and request checks remain.
    return undefined;
  }
}

export function announceSessionRevocation(): void {
  const channel = openSessionRevocationChannel();
  if (!channel) return;
  try {
    channel.postMessage('revoked');
  } catch {
    // Optional notification must not turn confirmed revocation into a failure.
  } finally {
    try {
      channel.close();
    } catch {
      // A browser channel cleanup failure cannot undo server-side revocation.
    }
  }
}
